<template>
  <div>
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="pie-chart" />
            <span>{{ $t("message.userGroupList.audience") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="usergroup-add" />
            <span>{{ $t("message.userGroupList.audienceList") }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title">{{ $t("message.userGroupList.audienceList") }}</div>

    <!--    Drawer  -->
    <!--    modal   -->


    <a-modal :visible="exportModal" :title="exportModalTitle" cancelText="取消" @cancel="exportCancel" width="40%"
      destroyOnClose>
      <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="请选择">
          <a-tree-select :size="$globalSize" v-model="exportData.key_id" show-search style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="Please select" allow-clear
            tree-default-expand-all>
            <a-tree-select-node v-for="item in ids" :key="item" :value="item" :title="item"></a-tree-select-node>
          </a-tree-select>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button :size="$globalSize" key="back" @click="exportCancel"> 取消</a-button>
        <a-button :size="$globalSize" key="submit" type="primary" :loading="exportLoading" @click="exportOk">
          导出
        </a-button>
      </template>
    </a-modal>
    <a-modal v-model="saveModal" :maskClosable="false" :title="$t('message.customGroup.SaveAudience')">
      <template slot="footer">
        <a-button :size="$globalSize" key="back" @click="closeSaveModal">
          {{ $t('message.commonUsage.cancel') }}
        </a-button>
        <a-button :size="$globalSize" key="submit" type="primary" :loading="loadingSpin" @click="save">
          {{ $t('message.commonUsage.save') }}
        </a-button>
      </template>
      <a-spin :spinning="spinningBtn">
        <a-form-model ref="saveForm" :rules="saveFormRules" :model="saveForm" :label-col="labelCol"
          :wrapper-col="wrapperCol">
          <a-form-model-item :label="$t('message.customGroup.CalculationType')" prop="group_type">
            <a-radio-group :size="$globalSize" v-model="saveForm.group_type" disabled>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{ $t('message.customGroup.DynamicTip') }}</span>
                </template>
                <a-radio :value="1"> {{ $t('message.customGroup.Dynamic') }}</a-radio>
              </a-tooltip>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{ $t('message.customGroup.StaticTip') }}</span>
                </template>
                <a-radio :value="2"> {{ $t('message.customGroup.Static') }}</a-radio>
              </a-tooltip>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item :label="$t('message.customGroup.title4')" prop="group_name">
            <a-input :size="$globalSize" v-model.trim="saveForm.group_name" :maxLength="64" :disabled="reload" />
          </a-form-model-item>
          <a-form-model-item :label="$t('message.customGroup.AudienceIDGenerate')" prop="autoid">
            <a-radio-group :size="$globalSize" v-model="saveForm.autoid" :disabled="autoidDisable">
              <a-radio :value="0">{{ $t('message.customGroup.Manually') }}</a-radio>
              <a-radio :value="1">{{ $t('message.customGroup.Autogen') }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item :label="$t('message.customGroup.title5')" prop="group_id" v-if="saveForm.autoid === 0">
            <!-- <a-input :size="$globalSize" v-model.trim="saveForm.group_id" :disabled="reload"/> -->
            <a-input-number :size="$globalSize" style="width:100%" :min="1" :max="9007199254740992" :step="1"
              v-model="saveForm.group_id" :disabled="reload || people_id_reload" />
          </a-form-model-item>
          <a-row v-if="saveForm.autoid === 0" style="margin-top:-20px;margin-bottom:20px;color:red;font-size:12px">
            <a-col :span="6"></a-col>
            <a-col :span="12">（{{ $t('message.customGroup.AudienceIDRange') }}：1~9,007,199,254,740,992）</a-col>
          </a-row>
          <!-- <a-form-model-item >
           <a-button  :size="$globalSize" >预览用户数</a-button>
          </a-form-model-item> -->
        </a-form-model>
      </a-spin>
    </a-modal>

    <!-- 分享 -->

    <a-card class="search mb16">
      <a-row :gutter="16">
        <a-col :md="{ span: 6 }" :xxl="{ span: 6 }">
          <a-input :size="$globalSize" :placeholder="$t('message.uploadGroup.title10')" v-model="filterForm.group_name"
            allowClear>
            <div slot="addonBefore">{{ $t("message.userGroupList.audienceName") }}：</div>
          </a-input>
        </a-col>
        <a-col :md="{ span: 8 }" :xxl="{ span: 8 }" style="line-height: 32px">
          <span class="black-color">{{ $t("message.userGroupList.groupType") }}：</span>
          <a-select :size="$globalSize" style="width: 70%" :placeholder="$t('message.userGroupList.groupType')"
            v-model="filterForm.group_type" allowClear>
            <a-select-option value="1">{{
              $t("message.userGroupList.regularAudience")
              }}
            </a-select-option>
            <a-select-option value="2">{{
              $t("message.userGroupList.uploadAudience")
            }}
            </a-select-option>

          </a-select>
        </a-col>
        <a-col :md="{ span: 6 }" :xxl="{ span: 6 }">
          <a-input :size="$globalSize" :placeholder="$t('message.userGroupList.creator')" allowClear
            v-model="filterForm.create_by">
            <div slot="addonBefore">
              {{ $t("message.userGroupList.creator") }}
              ：
            </div>
          </a-input>
        </a-col>
        <a-col :md="{ span: 1 }" :xxl="{ span: 2 }"></a-col>
        <a-col :md="{ span: 3 }" :xxl="{ span: 2 }">
          <a-button :size="$globalSize" type="primary"  class="my-btn" @click="searchKeyWord" style="float: right" :disabled="spinning">
            {{ $t("message.userGroupList.search") }}
          </a-button>
        </a-col>
      </a-row>
    </a-card>
    <div class="flex justify-content-end grid-gap-16">
      <a-button :size="$globalSize" type="primary" class="my-btn" @click="addUserGroup"
        :disabled="$store.getters.hasPermission($store.state.LIMIT_CONSTANTS.AUDIENCE_LIMIT)">
        {{ $t("message.userGroupList.createAudience") }}
      </a-button>
      <a-button :size="$globalSize" type="primary"  class="my-btn" @click="uploadCrowd"
        :disabled="$store.getters.hasPermission($store.state.LIMIT_CONSTANTS.AUDIENCE_LIMIT)">
        {{ $t("message.userGroupList.uploadAudience") }}
      </a-button>


      <a-button :size="$globalSize" type="primary" icon="close-circle" @click="onBatchDisable"
        v-if="selectedRowKeys.length > 0">
        批量禁用
      </a-button>
      <a-button :size="$globalSize" type="primary" icon="check-circle" @click="onBatchOpen"
        v-if="selectedRowKeys.length > 0">
        批量启用
      </a-button>
      <a-alert :message="'已选择 ' + this.selectedRowKeys.length + ' 项，是否选择全部？'" v-if="selectedRowKeys.length > 0"
        @close="cancelSelect" style="
              display: flex;
              height: 60px;
              background-color: rgba(154, 205, 252, 0.1);
              border: none;
              border-radius: 8px;
            ">
        <a-button :size="$globalSize" slot="description" type="link" @click="selectAllRows" style="
                border: none;
                color: #70b2ef;
                margin-top: -9px;
                margin-left: 25px;
                padding: 0px;
              ">选择全部
        </a-button>
        <a-button :size="$globalSize" slot="closeText" type="link" style="
                border: none;
                color: #70b2ef;
                margin-top: -9px;
                margin-left: 25px;
                padding: 0px;
              ">取消选择
        </a-button>
      </a-alert>
    </div>
    <a-card class="content mt16">
      <a-spin :spinning="spinning">
        <!-- :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
        <a-table id="userListTable" :columns="columns" :data-source="groups" row-key="group_id"
          :style="{ marginTop: selectedRowKeys.length > 0 ? '115px' : '35px' }" :scroll="{ x: 1500 }"
          :pagination="false">
          <template slot="user_count" slot-scope="text">
            <span v-text="showThousandNumber(text)"></span>
          </template>

          <template slot="group_type" slot-scope="text,record">
            <span v-html="groupTypeSet(record)"></span>
          </template>

          <template slot="create_time" slot-scope="text">
            <span class="table-time-color" v-text="convertToDefaultTimezone(showTime(text))"></span>
          </template>

          <template slot="calc_type" slot-scope="text">
            <span class="table-time-color"
              v-text="text == '1' ? $t('message.customGroup.Dynamic') : $t('message.customGroup.Static')"></span>
          </template>



          <template slot="group_name" slot-scope="text, record">
            <a href="javascript:;" :title="text" @click="userGroupDetail(record)"
              style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 100%;display: inline-block">
              {{ text }}
            </a>
          </template>

          <template slot="status" slot-scope="text,record">
            {{ statusSet(record.is_disabled) }}
          </template>

          <template slot="op" slot-scope="text, record">
            <my-button type="primary" shape="circle" v-if="record.group_type == 1" class="edit-btn-icon"
              style="margin-right: 10px;" @click="editUserGroup(record)" />
            <my-button type="primary" class="delete-btn-icon" shape="circle" @click="delUserGroup(record)" />
          </template>

          <template slot="is_disabled" slot-scope="text, record">
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{
                  !Number(text)
                    ? $t("message.userGroupList.enable")
                    : $t("message.userGroupList.disable")
                }}</span>
              </template>
              <a-switch checked-children="" un-checked-children="" :checked="!Number(text)"
                @click="disabledBtn(record)" />
            </a-tooltip>
          </template>
        </a-table>
        <div style="padding: 20px 0">
          <my-pagination ref="myPagination" :total="totalCount" @change="userGroupList"></my-pagination>
        </div>
      </a-spin>
      <!-- 配置弹窗 -->
      <a-modal title="配置API应用" :visible="updApplicationDialog" cancelText="取消" okText="保存"
        @cancel="updApplicationDialog = false" @ok="updApplication" width="900px" destroyOnClose>
        <a-form-model ref="updUserRuleForm" :model="updApplicationForm" :label-col="{ span: 4 }"
          :wrapper-col="{ span: 16 }">
          <a-form-model-item label="人群id" prop="group_id">
            <a-input :size="$globalSize" placeholder="请输入人群id" allowClear
              v-model="updApplicationForm.group_id"></a-input>
          </a-form-model-item>
          <a-form-model-item label="渠道AppId" prop="app_ids">
            <a-tree-select :size="$globalSize" v-model="updApplicationForm.app_ids" show-search
              :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }" placeholder="选择渠道" tree-checkable
              tree-default-expand-all treeNodeFilterProp="title">
              <a-tree-select-node v-for="parent in AppTreeData" :selectable="false" :key="parent.key"
                :value="parent.value" :title="parent.title + ' - ' + parent.key">
              </a-tree-select-node>
            </a-tree-select>
          </a-form-model-item>
        </a-form-model>
      </a-modal>

      <!-- 上传人群 -->
      <a-modal title="上传人群" :visible="uploadGroupShow" @cancel="uploadGroupShow = false" @ok="uploadGroupEvent"
        width="900px" destroyOnClose>
        <a-form-model ref="updUserRuleForm" :model="uploadGroupForm" :label-col="{ span: 4 }"
          :wrapper-col="{ span: 16 }">
          <!-- <a-form-model-item label="人群id生成规则" prop="group_id_flag">
            <a-radio-group :size="$globalSize" v-model="uploadGroupForm.flag">
              <a-radio value="1">自动生成</a-radio>
              <a-radio value="2">手动生成</a-radio>
            </a-radio-group>
          </a-form-model-item> -->

          <a-form-model-item v-if="uploadGroupForm.flag == 1 ? false : true" label="人群id" prop="group_id_flag">
            <a-input :size="$globalSize" placeholder="请输入人群id" allowClear v-model="uploadGroupForm.group_id"></a-input>
          </a-form-model-item>
          <a-form-model-item label="人群名称" prop="group_id">
            <a-input :size="$globalSize" placeholder="请输入人群名称" allowClear
              v-model="uploadGroupForm.group_name"></a-input>
          </a-form-model-item>
          <a-form-model-item label="人群sql" prop="group_sql">
            <a-textarea :size="$globalSize" placeholder="请输入人群sql" allowClear
              v-model="uploadGroupForm.group_sql"></a-textarea>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import utils from "@/utils";
import userGroupListService from "@/interface/pages/UserGroup/userList";
import addUserGroupService from "../../interface/pages/UserGroup/addUserGroup";
import userListService from "@/interface/pages/Authority/UserAuthority/userList";
import ChannelApplyService from "@/interface/pages/Setting/ChannelApply";
import MyPagination from "@/components/MyPagination";
import MyButton from "@/components/MyButton/index";
const exUser_options = [
  {
    key: "Age",
    title: "Age",
    label: "Age",
  },
  {
    key: "AgeGroup",
    title: "AgeGroup",
    label: "AgeGroup",
  },
  {
    key: "Constellation",
    title: "Constellation",
    label: "Constellation",
  },
  {
    key: "Gender",
    title: "Gender",
    label: "Gender",
  },
];
export default {
  name: "UserGroupList",
  components: {
    MyPagination,
    MyButton
  },

  data() {
    return {
      saveModal: false,
      reload: false,
      autoidDisable: false,
      people_id_reload: false,
      loadingSpin: false,
      spinningBtn: false,
      uploadGroupShow: false,
      updApplicationDialog: false,
      uploadGroupForm: {
        group_name: "",
        group_sql: "",
        flag: "1",
      },
      updApplicationForm: {
        user_name: localStorage.getItem("userName"),
        group_id: "",
        app_ids: [],
      },
      userAddShow: false,
      AppTreeData: "",
      spinning: true,
      exportType: "",
      button_property: localStorage.buttonProperty,
      groups: [],
      openKeys: ["sub1"], //默认展开
      columns: [
        {
          title: () => this.$t("message.userGroupList.audienceID"),
          dataIndex: "group_id",
          key: "group_id",
          sorter: (a, b) => a.id > b.id, //排序
          width: 170,
          fixed: "left",
        },
        {
          title: () => this.$t("message.userGroupList.audienceName"),
          dataIndex: "group_name",
          key: "group_name",
          scopedSlots: { customRender: "group_name" },
        },
        {
          title: () => this.$t("message.userGroupList.numberOfUsers"),
          align: "left",
          dataIndex: "user_count",
          key: "user_count",
          width: 100,
          sorter: (a, b) => a.user_count - b.user_count,
          scopedSlots: { customRender: "user_count" },
        },
        {
          title: () => this.$t("message.userGroupList.groupType"),
          align: "left",
          width: 150,
          dataIndex: "group_type",
          key: "group_type",
          scopedSlots: { customRender: "group_type" },
        },
        {
          title: () => this.$t("message.userGroupList.creator"),
          align: "left",
          width: 150,
          key: "created_user_name",
          dataIndex: "created_user_name",
        },
        {
          title: () => this.$t("message.userGroupList.creationTime"),
          align: "left",
          width: 200,
          dataIndex: "create_time",
          key: "create_time",
          sorter: (a, b) =>
            this.string2Date(a.create_time) - this.string2Date(b.create_time),
          scopedSlots: { customRender: "create_time" },
        },
        {
          title: () => this.$t("message.userGroupList.calculationType"),
          align: "left",
          width: 150,
          dataIndex: "calc_type",
          key: "calc_type",
          scopedSlots: { customRender: "calc_type" },
        },

        {
          title: () => this.$t("message.userGroupList.status"),
          align: "left",
          width: 80,
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: () => this.$t("message.userGroupList.operation"),
          align: "right",
          dataIndex: "op",
          fixed: "right",
          width: 150,
          key: "op",
          scopedSlots: { customRender: "op" }, //格式化，需要注意的是a-table中插槽的绑定
        },
        {
          title: () => {
            return (
              this.$t("message.userGroupList.disable") +
              "/" +
              this.$t("message.userGroupList.enable")
            );
          },
          align: "center",
          dataIndex: "is_disabled",
          key: "is_disabled",
          fixed: "right",
          width: 150,
          scopedSlots: { customRender: "is_disabled" },
        },
      ],
      totalCount: 0,

      ExPeopleNum: 0,
      shrinkForm: {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0,
        group_name: "",
        record: {},
      },
      peopleNum: 10240,
      pageSize: 10,
      exUser: false,
      shrinkUser: false,
      exUser_options,
      NumberOrPercent: true,
      exportModal: false,
      exportModalTitle: "",
      exportData: {
        cnd: "",
        tag_cnd: "",
        type: "",
        group_id: "",
        key_id: "",
        is_static: false,
      },
      exportLoading: false,
      visible: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      ids: ["m_vip_id"],
      // authorityButton: "",
      admin: false,
      selectedRowKeys: [],
      search: "",
      usersInfo: [],
      usersId: [],
      nowSelect: {},
      userList: [],
      filterForm: {
        group_name: null,
        group_type: undefined,
        create_by: null
      },
      saveForm: {
        group_name: "",
        group_type: 1,
        group_id: "",
        sourceGroupId: '',
        autoid: 1
      },
      saveFormRules: {
        group_name: [
          { required: true, message: this.$t('message.customGroup.FillinAudienceName'), trigger: "blur" }
        ],
        group_type: [
          { required: true, message: this.$t('message.customGroup.SelectCalculationType'), trigger: "blur" }
        ],
        autoid: [
          { required: true, message: this.$t('message.customGroup.SelectAudienceIDGenerationMethod'), trigger: "blur" }
        ],
        group_id: [
          { required: true, message: this.$t('message.customGroup.FillintheAudienceID'), trigger: "blur" }
        ]
      },
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 6 : 9
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 16 : 14
      },
    };
  },
  methods: {
    save() {
      this.$refs.saveForm.validate(valid => {
        if (valid) {
          this.loadingSpin = true
          this.spinningBtn = true
          let params = {
            groupName: this.saveForm.group_name,
            group_id: this.saveForm.group_id,
            sourceGroupId: this.saveForm.sourceGroupId
          }
          addUserGroupService
            .copyItemUserGroup(this, { data: params })
            .then(
              function (response) {
                let res = response.data;
                if (res.code == "200") {
                  this.$message.info('人群复制成功');
                  this.loadingSpin = false
                  this.spinningBtn = false
                  this.saveModal = false
                  this.userGroupList()
                } else {
                  this.$message.info(res.message);
                }
              }.bind(this)
            )
            .catch((response) => {
              console.log(response);
            }).finally(() => {
              this.loadingSpin = false
              this.spinningBtn = false
            });
        } else {
          return false
        }
      })
    },
    closeSaveModal() {
      this.$refs.saveForm.resetFields();
      this.saveModal = false;
    },
    uploadCrowd() {
      // this.$router.push({
      //   name: "UploadGroup",
      // });
      this.$router.push({
        name: 'UploadPackage',
        params: {
          tabKey: 'CDP源表'
        }
      })
    },
    // changeOption(value){
    //     console.log(JSON.stringify(value));
    //     console.log(JSON.stringify(this.uploadGroupForm))
    // },
    uploadGroupClick() {
      this.uploadGroupShow = true;
      this.uploadGroupForm.flag = "1";
      // console.log(JSON.stringify(this.uploadGroupForm));
    },

    uploadGroupEvent() {
      let param = {
        group_name: this.uploadGroupForm.group_name,
        group_sql: this.uploadGroupForm.group_sql,
      };
      if (this.uploadGroupForm.flag != "1") {
        param.group_id = this.uploadGroupForm.group_id;
      }
      userGroupListService
        .uploadGroupAjax(this, { data: param })
        .then(
          function (resp) {
            var res = resp.data;
            if (res.code == "200") {
              this.uploadGroupShow = false;
              this.$message.success(res.message);
              this.userGroupList();
            } else {
              this.$message.error(res.message);
            }
            this.uploadGroupForm = {
              flag: "1",
            };
          }.bind(this)
        )
        .catch((reason) => {
          console.log(reason);
        });
    },
    shareUser() {
      let body = {
        group_id: this.nowSelect.group_id,
        target_user_id: this.usersId.join(","),
      };
      addUserGroupService
        .shareUserGroup(this, { data: body })
        .then((response) => {
          if (response.data.code == "200") {
            this.userAddShow = false;
            this.$message.success("分享成功！");
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((response) => {
          this.userAddShow = false;
        });
    },
    getAllApiChannel() {
      let param = {};
      ChannelApplyService.getAllApiChannel(this, { params: param })
        .then(
          function (resp) {
            let res = resp.data;
            if (res.code == "200") {
              this.AppTreeData = res.data;
            }
          }.bind(this)
        )
        .catch((reason) => {
          console.log(reason);
        });
    },
    openSettingDialog(text, record) {
      this.updApplicationDialog = true;
      let that = this;
      this.updApplicationForm.group_id = record.group_id;
      let body = {
        group_id: record.group_id,
      };
      ChannelApplyService.getApiChannel(this, { params: body })
        .then(function (response) {
          let res = response.data;
          if (res.code == "200") {
            that.updApplicationForm.app_ids = res.data;
          }
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    queryAllUser() {
      let body = {
        user_id: localStorage.getItem("userId"),
      };
      userListService
        .queryAllUser(this, { params: body })
        .then((response) => {
          let res = response.data;
          if (res.code == 200) {
            this.usersInfo = res.data;
            this.usersInfo.forEach((item) => {
              item.value = item.user_id;
            });
            // this.$message.success("查询成功！");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          console.log("查询失败！");
        });
    },
    statusSet(val) {
      let status = "";
      if (val === "0") {
        status = this.$t("message.userGroupList.enable");
      } else if (val === "1") {
        status = this.$t("message.userGroupList.disable");
      }



      return status;
    },
    groupTypeSet(record) {
      const val = record.group_type;
      let group_type = "";
      if (val == 1) {
        group_type = this.$t("message.userGroupList.regularAudience");
      } else if (val == 2) {
        group_type = this.$t("message.userGroupList.uploadAudience");
      } else if (val == 3) {
        group_type = this.$t("message.userGroupList.customAudience");
      } else if (val == 4) {
        const type = this.getDataType(record.info_type)
        group_type = `<div>
          <div>${this.$t("message.uploadPackage.title2")}</div>
          <div>(` + type + `)</div>
        </div>`
      } else if (val == 5) {
        group_type = '组合人群';
      }
      return group_type;
    },
    getDataType(val) {
      let value_type = "";
      if (val == 'phone') {
        value_type = '手机号';
      } else if (val == 'member_id') {
        value_type = 'memberId';
      } else if (val == 'union_id') {
        value_type = 'unionId';
      } else if (val == 'email') {
        value_type = '邮箱'
      }
      return value_type;
    },
    // 搜索
    searchKeyWord() {
      this.$refs.myPagination.initCurrent()
      this.userGroupList()
    },
    // 查询列表数据
    userGroupList() {
      this.spinning = true;
      let body = {
        ...this.filterForm,
        ...this.$refs.myPagination.pagination
      };
      userGroupListService
        .userGroupList(this, { params: body })
        .then((response) => {
          let res = response.data;
          if (res.code == 200) {
            this.groups = res.data;
            this.totalCount = res.totalCount
            setTimeout(() => {
              this.spinning = false;
              this.$message.success(res.message);
            }, 800);
          } else {
            if (res.code !== '400') {
              this.$message.error(res.message);
            }
          }
        })
        .catch((error) => {
          console.log("查询失败！" + error);
        });
    },

    showDrawer() {
      this.visible = true;
    },
    handleClick() {

    },
    onClose() {
      this.visible = false;
    },
    userGroupDetail(record) {
      switch (record.group_type) {
        // 普通人群
        case "1":
          this.$router.push({
            name: "UserGroupDetail",
            params: {
              tag_cnd: record.tag_cnd,
              user_count: record.user_count,
              readonly: true
            },
          });
          break;
        // 上传人群
        case "2":
          break;
        // 自定义人群
        case "3":

          break;
        // 上传人群包
        case "4":
          break;
      }

    },
    //配置AIP
    updApplication() {
      ChannelApplyService.updChannel(this, { data: this.updApplicationForm })
        .then(
          function (resp) {
            var res = resp.data;
            console.log(res);
            if (res.code == "200") {
              this.updApplicationDialog = false;
              this.$message.success(res.message);
              this.getAppList();
            } else {
              this.$message.error(res.message);
            }
          }.bind(this)
        )
        .catch((reason) => {
          console.log(reason);
        });
    },
    // 分析按钮点击事件
    toMainUserGroupView(row) {
      if (row.is_disabled) {
        this.$message.info("当前人群已禁用，暂不支持分析功能！");
        return;
      }
      if (row.status != 2) {
        this.$message.info("当前人群未完成更新，暂不支持分析功能！");
        return;
      }
      let time_tmp = JSON.parse(row.tag_cnd).unionForm;
      const newPath = this.$router.resolve({
        path: "/dataAnalysis/userAnalysis",
        query: {
          group_id: row.group_id,
          // oms_time_range: time_tmp.timeRange1,
          // crm_time_range: time_tmp.timeRange2,
          // sensor_time_range: time_tmp.timeRange3,
        },
      });
      window.open(newPath.href, "_blank");
    },

    // 复制
    copyUserGroup(record) {
      if (record.is_disabled) {
        this.$message.info("当前人群已禁用，暂不支持复制功能！");
        return;
      }
      if (record.status != 2) {
        this.$message.info("当前人群未完成更新，暂不支持复制功能！");
        return;
      }
      if (record.group_type == 1) {
        this.$router.push({
          name: "AddUserGroupV2",
          params: {
            // 复制创建新人群 不携带
            userGroupId: "",
            userGroupName: "",
            tag_cnd: record.tag_cnd,
          },
        });
      } else if (record.group_type == 5) {
        this.saveForm.sourceGroupId = record.group_id
        this.saveModal = true
      }
    },
    // 编辑人群
    editUserGroup(record) {
      if (record.status == "0") {
        this.$message.info("当前人群已禁用，暂不支持编辑功能！");
        return;
      }

      let group_type = record.group_type;
      if (group_type == 2) {
        // 上传人群
        this.$router.push({
          name: "UploadPackage",
          params: {
            // 编辑人群 携带
            user_count: record.user_count,
            group_id: record.group_id,
          },
        });
      } else {
        this.$router.push({
          name: "AddUserGroup",
          params: {
            // 编辑人群 携带
            group_id: record.group_id,
            userGroupName: record.group_name,
            userGroupType: record.group_type,
            tag_cnd: record.tag_cnd,
          },
        });
      }
    },

    exUserCancel() {
      this.exUser = false;
      this.$message.warning("操作取消！");
    },
    exUserOk() {
      this.exUser = false;
      this.$message.success("操作成功！");
    },
    // 导出
    exportFile(record, type) {
      if (record.is_disabled) {
        this.$message.info("当前人群已禁用，暂不支持导出功能！");
        return;
      }
      if (record.status != 2) {
        this.$message.info("当前人群未完成更新，暂不支持导出功能！");
        return;
      }
      if (record.user_count > 300000) {
        this.$message.info("当前人群数据量过大，请联系管理员！");
        return;
      }
      this.exportData = {
        cnd: record.cnd,
        tag_cnd: record.tag_cnd,
        type: type,
        group_id: record.group_id,
        key_id: "m_vip_id",
        is_static: record.calc_type == "1" ? false : true,
      };
      this.exportModal = true;
      this.exportModalTitle = "导出" + type.toUpperCase() + "文件";
    },
    exportCancel() {
      if (this.exportLoading) {
        var that = this;
        this.$confirm({
          title: "关闭对话框仍继续下载文件，是否继续关闭对话框？",
          okType: "primary",
          onOk() {
            that.exportModal = false;
          },
          onCancel() {
            that.$message.warning("取消关闭操作！");
          },
        });
      } else {
        this.exportModal = false;
        this.$message.warning("已取消导出！");
      }
    },
    exportOk() {
      let body = this.exportData;
      this.exportLoading = true;
      userGroupListService
        .exportUserGroup(this, { data: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              if (res.data.length > 0) {
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = res.data;
                link.download = "application/octet-stream;charset=utf-8";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.$message.success("导出成功！");
              } else {
                this.$message.success("当前暂无数据，系统正在重新计算！");
              }
              setTimeout(() => {
                this.exportLoading = false;
                this.exportModal = false;
              }, 600);
            } else {
              this.$message.warning(res.message);
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
          this.$message.success("导出异常！");
          setTimeout(() => {
            this.exportLoading = false;
            this.exportModal = false;
          }, 600);
        });
    },
    // 创建人群
    addUserGroup() {
      // const newPath = this.$router.resolve({
      //     path: "/dataAnalysis/addUserGroup",
      // });
      // window.open(newPath.href, "_blank");
      this.$router.push("/audience/addUserGroup");
    },
    // 格式化时间
    showTime(value) {
      if (typeof value == "undefined" || value == null || !value) {
        return "-";
      }
      return utils.formatDate(new Date(value), "yyyy-MM-dd hh:mm:ss");
    },
    // 格式化数字
    showThousandNumber(value) {
      return utils.showThousandNumber(value);
    },
    // 随机人群相关操作
    shrinkUserGroup(record) {
      if (record.is_disabled) {
        this.$message.info("当前人群已禁用，暂不支持随机功能！");
        return;
      }
      if (record.status != 2) {
        this.$message.info("当前人群未完成更新，暂不支持随机功能！");
        return;
      }
      if (record.op_type != "新建") {
        this.$message.info("当前人群非种子人群，暂不支持随机功能！");
        return;
      }
      this.shrinkForm.record = record;
      this.shrinkForm.shrink_user_num = record.user_count;
      let num_tmp = String(record.user_count / 10);
      if (num_tmp.indexOf(".") >= 0) {
        num_tmp = num_tmp.substring(0, num_tmp.indexOf("."));
      }
      this.shrinkForm.shrink_input = Number(num_tmp) > 100000 ? 100000 : Number(num_tmp);
      this.shrinkUser = true;
    },
    shrinkSlideFormatter(value) {
      if (this.shrinkForm.shrink_switch) {
        return `随机抽取${value}%`;
      } else {
        return `随机抽取${value}倍`;
      }
    },
    shrinkSwitchChange(value) {
      this.shrinkForm.shrink_slide = 10;
      let num_tmp = String(this.shrinkForm.shrink_user_num / 10);
      if (num_tmp.indexOf(".") >= 0) {
        num_tmp = num_tmp.substring(0, num_tmp.indexOf("."));
      }
      this.shrinkForm.shrink_input = Number(num_tmp) > 100000 ? 100000 : Number(num_tmp);
    },
    shrinkSlideChange(value) {
      let num_tmp = String(
        (this.shrinkForm.shrink_slide * this.shrinkForm.shrink_user_num) / 100
      );
      if (num_tmp.indexOf(".") >= 0) {
        num_tmp = num_tmp.substring(0, num_tmp.indexOf("."));
      }
      this.shrinkForm.shrink_input = Number(num_tmp) > 100000 ? 100000 : Number(num_tmp);
    },
    shrinkUserOk() {
      let tag_cnd = JSON.parse(this.shrinkForm.record.tag_cnd);
      tag_cnd["random_count"] = this.shrinkForm.shrink_input;
      let body = {
        group_name: this.shrinkForm.group_name,
        user_count:
          this.shrinkForm.shrink_input > 100000 ? 100000 : this.shrinkForm.shrink_input,
        group_type: "我创建的",
        calc_type: this.shrinkForm.record.calc_type,
        status: 2,
        is_disabled: 0,
        cnd: this.shrinkForm.record.cnd,
        tag_cnd: JSON.stringify(tag_cnd),
        source_group_id: this.shrinkForm.record.group_id,
        op_type: "随机",
      };
      userGroupListService
        .randomUserGroup(this, { data: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.userGroupList();
              setTimeout(() => {
                this.spinning = false;
                this.$message.info(res.message);
              }, 800);
            } else {
              this.$message.info(res.message);
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        });
      this.shrinkUser = false;
    },
    shrinkUserCancel() {
      this.shrinkUser = false;
      this.$message.warning("操作取消！");
    },
    // 删除
    async delUserGroup(record) {
      var that = this;
      const { data: res } = await userGroupListService.checkPeopleEvent(that, { params: { segmentId: record.group_id, loginId: localStorage.getItem('userId') } })
      if (res.code == "200") {
        if (res.data > 0) {
          this.$message.warning(
            this.$t("message.userGroupList.theAudienceIsNotAllowDelete")
          );
        } else {
          this.$confirm({
            title: this.$t("message.userGroupList.deleteTheAudienceConfirm"),
            okText: this.$t("message.userGroupList.confirm"),
            okType: "primary",
            cancelText: this.$t("message.userGroupList.cancel"),
            onOk() {
              return new Promise((resolve) => {
                let body = {
                  segmentId: String(record.group_id),
                };
                userGroupListService
                  .delPopulation(that, { data: body })
                  .then(
                    function (response) {
                      let res = response.data;
                      if (res.code == "200") {
                        this.$store.dispatch('fetchButtonPermission')
                        this.userGroupList();
                        setTimeout(() => {
                          resolve();
                        }, 800);
                      } else {
                        that.$message.info(res.message);
                      }
                    }.bind(that)
                  )
                  .catch((response) => {
                    console.log(response);
                  });
              });
            },
            onCancel() {
              that.$message.warning(
                that.$t("message.userGroupList.cancelDeleteOpration")
              );
            },
          });
        }
      }
    },
    // 禁用
    disabledBtn(record) {
      var that = this;
      this.$confirm({
        title: record.is_disabled == 1
          ? this.$t("message.userGroupList.enableThisAudienceConfirm")
          : this.$t("message.userGroupList.disableThisAudienceConfirm"),
        okText: this.$t("message.userGroupList.confirm"),
        okType: "primary",
        cancelText: this.$t("message.userGroupList.cancel"),
        onOk() {
          return new Promise((resolve) => {
            that.disabledConfirm(record, resolve)
          });
        },
        onCancel() {
          that.$message.warning(
            record.is_disabled
              ? that.$t("message.userGroupList.enableThisAudienceCancel")
              : that.$t("message.userGroupList.disableThisAudienceCancel")
          );
        },
      });
    },
    disabledConfirm(record, resolve) {
      let body = {
        segmentId: record.group_id,
        is_disabled: record.is_disabled == 0 ? 1 : 0,
        loginId: localStorage.getItem('userId')
      };
      userGroupListService
        .disableUserGroup(this, { data: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.userGroupList();
              setTimeout(() => {
                this.spinning = false;
                this.$message.info(res.message);
                resolve()
              }, 800);
            } else {
              this.$message.info(res.message);
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        });
    },
    // 批量操作
    onSelectChange(selectedRowKeys, row) {
      this.selectedRowKeys = selectedRowKeys;
    },
    cancelSelect() {
      this.selectedRowKeys = [];
    },
    selectAllRows() {
      var allRowKeys = [];
      var size = this.groups.length;
      for (var i = 0; i < size; i++) {
        allRowKeys.push(this.groups[i].id);
      }
      this.selectedRowKeys = allRowKeys;
    },
    onBatchOpen() {
      let that = this;
      this.$confirm({
        title: "确定批量启用ID为：" + that.selectedRowKeys.toString() + "的人群吗？",
        content: "注意：已被启用的人群不会发生变化！",
        okText: "批量启用",
        okType: "primary",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve) => {
            this.spinning = true;
            let body = {
              ids: that.selectedRowKeys.toString(),
              is_disabled: 0,
            };
            userGroupListService
              .batchDisable(that, { data: body })
              .then(
                function (response) {
                  let res = response.data;
                  if (res.code == "200") {
                    resolve()
                    that.$message.success(res.message);
                  } else {
                    that.$message.error(res.message);
                  }
                  setTimeout(() => {
                    that.userGroupList();
                  }, 500);
                }.bind(that)
              )
              .catch((response) => {
                console.log(response);
              });
          });
        },
        onCancel() {
          that.$message.warning("批量启用操作取消！");
        },
      });
    },
    onBatchDisable() {
      let that = this;
      this.$confirm({
        title: "确定批量禁用ID为：" + that.selectedRowKeys.toString() + "的人群吗？",
        content: "注意：已被禁用的人群不会发生变化！",
        okText: "批量禁用",
        okType: "primary",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve) => {
            this.spinning = true;
            let body = {
              ids: that.selectedRowKeys.toString(),
              is_disabled: 1,
            };
            userGroupListService
              .batchDisable(that, { data: body })
              .then(
                function (response) {
                  let res = response.data;
                  if (res.code == "200") {
                    resolve()
                    that.$message.success(res.message);
                  } else {
                    that.$message.error(res.message);
                  }
                  setTimeout(() => {
                    that.userGroupList();
                  }, 500);
                }.bind(that)
              )
              .catch((response) => {
                console.log(response);
              });
          })
        },
        onCancel() {
          that.$message.warning("批量禁用操作取消！");
        },
      });
    },
    string2Date(str) {
      return new Date(str);
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .ant-table-placeholder {
  height: 500px;
}

#userListTable .ant-btn {
  padding: 0 0 0 10px;
}

.group-table ::v-deep .ant-table-tbody tr {
  height: 90px !important;
}
</style>
